import * as T from 'three';
/** Pale natural white oak, with a subtle grain and readable indirect underside light. */
export function createOakSoffitMaterial(){
 const width=128,height=256,data=new Uint8Array(width*height*4);
 for(let y=0;y<height;y++)for(let x=0;x<width;x++){
  const bend=2*Math.sin(y*.023)+.7*Math.sin(y*.071);
  const grain=Math.sin((x+bend)*.65)*.018+Math.sin((x+bend)*2.8)*.009+Math.sin(x*13.7+y*7.3)*.004;
  const i=(y*width+x)*4;
  data[i]=Math.round(235*(1+grain));data[i+1]=Math.round(218*(1+grain));data[i+2]=Math.round(189*(1+grain));data[i+3]=255;
 }
 const map=new T.DataTexture(data,width,height);map.colorSpace=T.SRGBColorSpace;map.magFilter=T.LinearFilter;map.minFilter=T.LinearFilter;map.needsUpdate=true;
 const material=new T.MeshPhysicalMaterial({color:0xffffff,map,roughness:.24,metalness:0,clearcoat:1,clearcoatRoughness:.12,emissive:0xffffff,emissiveMap:map,emissiveIntensity:.65});
 material.addEventListener('dispose',()=>map.dispose());return material;
}
